/**
 * `dashboard` namespace — Korean translations.
 *
 * Mirrors `en/dashboard.ts` exactly; the `Record<DashboardKey, string>`
 * annotation makes a missing or misspelled key a compile error, so this file
 * cannot drift from the canonical English source. Concise 명사형/합니다체 for
 * panel chrome; glossary terms (대시보드/자산 배분/전략별 손익) applied consistently.
 */
import type { DashboardKey } from "../en/dashboard";

export const dashboard: Record<DashboardKey, string> = {
  // ── overview route chrome ──
  overviewEyebrow: "개요",
  description: "포트폴리오 가치, 시장 손익과 입출금 분해, 자산 배분, 전략 성과.",

  // ── panel titles (shared with the portfolio route) ──
  panelPortfolioValue: "포트폴리오 가치",
  panelDecomposition: "시장 손익과 입출금 분해",
  panelAllocation: "자산 배분",
  panelStrategyPnl: "전략별 손익",

  // ── panel states ──
  panelErrorTitle: "불러오지 못했습니다",
  strategyPnlLoadError: "전략 성과를 불러오지 못했습니다.",
};
